import Rest from '@services/Rest'

/**
 * @typedef {RefundService}
 */
export default class RefundService extends Rest {
  /**
   * @type {String}
   */
  // '/erp/refund-solicitation' -- ainda nao subiu o back
  static resource = '/refund-solicitation'
}
